import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=731086ff&scoped=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"
import style0 from "./Title.vue?vue&type=style&index=0&id=731086ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731086ff",
  null
  
)

export default component.exports